import { useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  pdf,
} from "@react-pdf/renderer";
import dateFormat, { formatDateTime } from "../../../../../../utils/dateFormat";

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 8,
    padding: 20,
  },
  clientInfo: {
    marginBottom: 12,
    fontSize: 10,
  },
  table: {
    display: "table",
    width: "auto",
    border: "1px solid #bfbfbf",
  },
  tableRow: {
    borderBottom: "1px solid #dfdfdf",
    flexDirection: "row",
  },
  tableHeader: {
    backgroundColor: "#003366",
    color: "#ffffff",
    fontWeight: "bold",
  },
  tableCol: {
    flex: 1,
    padding: 4,
  },
  tableCell: {
    textAlign: "center",
  },
});

const MyDocument = ({ client, date, objects }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.clientInfo}>
        <Text>Client Name: {client}</Text>
        <Text>
          Date:{" "}
          {date?.gte
            ? `${dateFormat(date.gte)} - ${dateFormat(date.lte)}`
            : "All"}
        </Text>
        <Text>Total: {objects?.length}</Text>
      </View>

      <View style={styles.table}>
        <View style={[styles.tableRow, styles.tableHeader]}>
          <Text style={[styles.tableCol, styles.tableCell]}>Searched Name</Text>
          <Text style={[styles.tableCol, styles.tableCell]}>
            Affiliate User
          </Text>
          <Text style={[styles.tableCol, styles.tableCell]}>Search Date</Text>
          <Text style={[styles.tableCol, styles.tableCell]}>Client</Text>
          <Text style={[styles.tableCol, styles.tableCell]}>Branch</Text>
        </View>

        {objects.map((log, index) => (
          <View key={index} style={styles.tableRow}>
            <Text style={[styles.tableCol, styles.tableCell]}>
              {log.searched_first_name ||
              log.searched_middle_name ||
              log.searched_last_name ||
              log.searched_alias
                ? `${log.searched_first_name || ""} ${
                    log.searched_middle_name || ""
                  } ${log.searched_last_name || ""} ${
                    log.searched_alias || ""
                  }`.trim()
                : log.searched_company}
            </Text>
            <Text style={[styles.tableCol, styles.tableCell]}>
              {`${log.searcher.firstName} ${log.searcher.middleName || ""} ${
                log.searcher.lastName
              }`}
            </Text>
            <Text style={[styles.tableCol, styles.tableCell]}>
              {formatDateTime(log.createdAt)}
            </Text>
            <Text style={[styles.tableCol, styles.tableCell]}>
              {log.searcher?.affiliate?._id}
            </Text>
            <Text style={[styles.tableCol, styles.tableCell]}>
              {log.searcher?.branch?.code || log.searcher?.branch?._id}
            </Text>
          </View>
        ))}
      </View>
    </Page>
  </Document>
);

export default function ExportPDF({ client, date, objects }) {
  const [generating, setGenerating] = useState(false);

  const handleExport = async () => {
    if (generating || objects.length === 0) return;
    setGenerating(true);
    try {
      const blob = await pdf(
        <MyDocument client={client} date={date} objects={objects} />,
      ).toBlob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "search_logs.pdf";
      a.click();
      URL.revokeObjectURL(url);
    } finally {
      setGenerating(false);
    }
  };

  return (
    <button
      className="btn btn-primary"
      onClick={handleExport}
      disabled={generating || objects.length === 0}
    >
      {generating ? "Generating PDF..." : "Export PDF"}
    </button>
  );
}
